import { render } from "./VerDatosEnvio.vue?vue&type=template&id=2be7fb5f&scoped=true"
import script from "./VerDatosEnvio.vue?vue&type=script&lang=js"
export * from "./VerDatosEnvio.vue?vue&type=script&lang=js"

import "./VerDatosEnvio.vue?vue&type=style&index=0&id=2be7fb5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be7fb5f"]])

export default __exports__